<template>
  <div class="widget">
    <h3>讨论/问答
      <router-link to="/help" class="more">更多&gt;</router-link>
    </h3>
    <ul>
      <li v-for="item in tableData" :key="item.help_id">
        <router-link :to="`/helpcontent/${item.help_id}`" class="w-title">{{ item.help_title }}</router-link>
        <div class="w-meta">
          <span class="icon">🕐</span>{{ item.createtime | dataFormat }}
          <span class="read"><span class="icon">👁</span>{{ item.help_read_num }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getHelpList } from '@/api'

export default {
  name: 'HelpWidget',
  data() {
    return { tableData: [] }
  },
  created() {
    getHelpList({ page: 1, pagesize: 5 }).then((res) => {
      this.tableData = res.data || []
    })
  }
}
</script>
